import { Order } from '../../../types';

const MINUTE_MS = 60000;

const hasScheduledWindow = (order: Order): boolean =>
    typeof order.scheduledStartAt === 'number' && order.scheduledStartAt > 0;

export const isScheduledOrder = (order: Order): boolean =>
    order.orderTiming === 'scheduled' || order.status === 'scheduled_confirmed' || hasScheduledWindow(order);

export const getMinutesUntilScheduledStart = (order: Order, now: number = Date.now()): number | null => {
    if (!hasScheduledWindow(order)) return null;
    return Math.ceil((order.scheduledStartAt! - now) / MINUTE_MS);
};

export const isScheduledRoutingEligible = (
    order: Order,
    leadMinutes: number,
    now: number = Date.now()
): boolean => {
    if (order.status !== 'scheduled_confirmed') return true;

    const minsUntilStart = getMinutesUntilScheduledStart(order, now);
    if (minsUntilStart === null) return true;

    return minsUntilStart <= leadMinutes;
};
